import { ITutorial, ITutorialPassos, MensagensPadrao } from "../../../Components/AdicionarAjuda";

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-conta",

    filtroDeNomeConta: "campo-nome-filtros-conta",
    filtroDeNumeroConta: "campo-numero-filtros-conta",
    filtroDeAtivo: "campo-ativo-filtros-conta",

    botaoListar: "botao-listar-contas",
    botaoAdicionar: "botao-adicionar-conta",
}

export const Classes = {
    botaoEditar: "botao-editar-conta",
    botaoDesativar: "botao-desativar-conta",
}

export const ConsultarConta: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)!},
        {...MensagensPadrao.filtros.nome, target: () => document.getElementById(IDs.filtroDeNomeConta)!},
        {
            title: "Filtro de número de conta",
            description: "Caso deseje filtrar pelo número de uma conta, especifique-o neste campo.",
            target: () => document.getElementById(IDs.filtroDeNumeroConta)!
        },
        {...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)!},
        {...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)!},
    ]
}

export const AdicionarConta: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)!},
    ]
}

export const EditarConta: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)!},
    ]
}

export const DesativarConta: ITutorialPassos = {
    steps: [
        {...MensagensPadrao.alterar.desativar, target: () => document.querySelector('.' + Classes.botaoDesativar)!},
    ]
}

// const tutorialMenuItems: ITutorial[] = [
//     {
//         titulo: "Como consultar centros de custos",
//         tutorial: tutorialConsultarCentro
//     },
//     {
//         titulo: "Como cadastrar um novo centro de custos",
//         tutorial: tutorialAdicionarCentro
//     },
//     {
//         titulo: "Como editar um centro de custos",
//         tutorial: tutorialEditarCentro
//     },
//     {
//         titulo: "Como desativar um centro de custos",
//         tutorial: tutorialDesativarCentro
//     }
// ]